import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";
//import { browserHistory } from 'react-router'
import config from "../../config";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import {
  postInstitutionDriveApproval,
  getListInstitutionJobApproval,
} from "../Actions/DriveAction";
import { token, roleid, username } from "../Actions/AuthAction";
import Loader from "../Common/Loader";
import ShowError from "../Common/Error";
import { setError } from "../../utils";
import ReactQuill from "react-quill";
import { getUpdatedActiveIndex } from "react-bootstrap-typeahead/types/utils";
import Swal from "sweetalert2";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};
const InstitutionApprovalMessage = (props) => {
  console.log(props, "rerendered");
  const [datamsg, setDatamsg] = useState(null);
  const [replycomment, setreplycomment] = useState(null);
  const form = useRef();
  const checkBtn = useRef();
  //const [approvalList, setApprovalList] = useState({ value: '', error: '', options: [], isRequired: true });

  const approvalList = [
    {
      id: 0,
      name: "Pending",
    },
    {
      id: 1,
      name: "Approved",
    },
    {
      id: 2,
      name: "Rejected",
    },
  ];
  const [approval, setApproval] = useState({
    value: "",
    error: "",
    options: [],
    isRequired: true,
  });
  const [university, setUniversity] = useState({
    value: "",
    error: "",
    isRequired: true,
  });
  const [datamessage, setDatamessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [setpasserror, setPassError] = useState(false);
  const [message, setMessage] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [universityListData, setUniversityListData] = useState(
    props.institutionslist
  );
  const [showReplyBox, setShowReplyBox] = useState(0);
  const pagepath = "/jobdetail/" + props.jobid;
  const redirectpath = "/jobdetail/" + props.jobid;

  const renderuniversity = (unicode, numberIndex) => {
    return (
      props.message.length > 0 &&
      props.message.map((item, i) => {
        if (item.senderid == unicode || item.reciverid == unicode) {
          return (
            <div class="chat-body clearfix">
              <div class="header">
                <small class="pull-right text-muted">
                  <span class="glyphicon glyphicon-time"></span>
                  {item.createdat}
                </small>
              </div>
              <p className="m-1">
                {<span dangerouslySetInnerHTML={{ __html: item.message }} />} (
                {item.sendername}) ,{" "}
                {item.status == 1 ? (
                  <span className="text-default">
                    <i>Pending</i>
                  </span>
                ) : item.status == 2 ? (
                  <span className="text-success">
                    <i>Approved</i>
                  </span>
                ) : item.status == 3 ? (
                  <span className="text-danger">
                    <i>Rejected</i>
                  </span>
                ) : (
                  <span></span>
                )}
              </p>
            </div>
          );
        }
      })
    );
  };
  let history = useHistory();

  useEffect(() => {
    setMessage(props.message);

    // getData()
  }, [props.message]);

  const getData = () => {
    getListInstitutionJobApproval({
      key: token(),
      page: "-1",
      driveid: props.driveid,
    }).then((res) => {
      setMessage(res.data);
    });
  };

  const handleReplyComment = (instituteid) => {
    postInstitutionDriveApproval({
      key: token(),
      driveid: props.driveid,
      message: datamsg,
      status: 3,
      instituteid: instituteid,
    }).then((res) => {
      props.getmsg();

      //alert(res);
      if (res.status) {
        Swal.fire({
          icon: "success",
          title: "Done.",
          text: "Congractulations!",
          footer: res.message,
        });

        //history.push("/universityadd");
        //window.location.reload();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: res.message,
        });
        return false;
      }
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    //localStorage.setItem("test", 'dfasdf');
    //alert(password);return false;

    setMessage("");
    setLoading(true);

    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      postInstitutionDriveApproval({
        key: token(),
        jobid: props.jobid,
        reciverid: university.value,
        message: datamessage,
      }).then((res) => {
        //alert(res);
        if (res.status) {
          setError(res.message);
          setPassError(true);
          setLoading(false);
          setStatus(res.status);
          getData();

          //history.push("/universityadd");
          //window.location.reload();
        } else {
          setError(res.message);
          setPassError(false);
          setLoading(false);
          return false;
        }
      });
    } else {
      setLoading(false);
    }
  };
  const renderDriveMessage = (item, name = null) => {
    return (
      <React.Fragment>
        <div className="chat-body clearfix">
          <div className="d-flex justify-content-between py-2 mb-2">
            <div className="col-md-10">
              <span dangerouslySetInnerHTML={{ __html: item.message }} />
              <p>
                <strong>
                  ({name}), {item.createdate}
                </strong>
              </p>
            </div>
            <div className="col-md-2 text-right">
              <span>Status:</span>{" "}
              {item.status == 1 ? (
                <span className="text-warning aspanprovebtn">Pending</span>
              ) : item.status == 2 ? (
                <span className="text-success approvebtn">Approved</span>
              ) : item.status == 3 ? (
                <span className="text-danger approvebtn">Rejected</span>
              ) : (
                <span></span>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
  const updateShowReplyBox = (e, universityid) => {
    setShowReplyBox(e);
    setUniversity({ ...university, value: universityid });
  };

  const onHideModal = () => {
    setError(undefined);
  };
  return (
    <>
      {loading && <Loader />}

      {error && (
        <ShowError
          datastatus={status}
          datapagepath={pagepath}
          dataredirectpath={redirectpath}
          message={error}
          passerror={setpasserror}
          toggleModal={onHideModal}
          datarefresh={refresh}
        />
      )}
      <div className="col-md-12">
        <h4 className="table_heading">MESSAGE</h4>
      </div>
      <div className="card formcard m-3">
        <div className="card-body">
          <ul class="chat">
            <li class="left clearfix">
              {/* <span class="chat-img">
                            <img src="http://placehold.it/50/55C1E7/fff&text=U" alt="User Avatar" class="img-circle" />
                        </span> */}
              {roleid() == 2 ? (
                <>
                  <span>1.) </span>
                  <strong class="primary-font">{username()} (Institute)</strong>
                </>
              ) : null}
              {roleid() == 2 &&
                message &&
                message.map((item, index) => {
                  return <>{renderDriveMessage(item, item.sendername)}</>;
                })}
              {(roleid() == 3 || roleid() == 1) &&
                props &&
                props.institutionslist.map((item, index) => {
                  return (
                    <div>
                      <strong>
                        {" "}
                        {index + 1}.) {item.institute.name}
                      </strong>

                      {message && message.length ? (
                        message.map((item2, index2) => {
                          if (item.institute.id == item2.senderid) {
                            return (
                              <>
                                {renderDriveMessage(item2, item.institute.name)}
                              </>
                            );
                          }
                          if (item.institute.id == item2.reciverid)
                            return <>{renderDriveMessage(item2, username())}</>;
                        })
                      ) : (
                        <>No Messages</>
                      )}
                      {message && message.length ? (
                        replycomment == item.institute.id ? (
                          <p>
                            Comment
                            <ReactQuill
                              value={datamsg}
                              onChange={(e) => setDatamsg(e)}
                            />
                            <button
                              className="btn btn-primary-custom mx-2"
                              onClick={(e) =>
                                handleReplyComment(item.institute.id)
                              }
                            >
                              Send
                            </button>
                            <button
                              className="btn btn-secondary-custom mx-2"
                              onClick={(e) => setreplycomment(null)}
                            >
                              Close
                            </button>
                          </p>
                        ) : message &&
                          message[message.length - 1].status != 2 ? (
                          <p>
                            <button
                              className="btn btn-secondary"
                              onClick={(e) =>
                                setreplycomment(item.institute.id)
                              }
                            >
                              Reply
                            </button>
                          </p>
                        ) : (
                          <span></span>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  );
                })}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default InstitutionApprovalMessage;
